<script>
import api from './api'
export default {
  list (params) {
    return api.get('channels', params)
  }
}
</script>



// WEBPACK FOOTER //
// channels.vue?59f5e998